document.addEventListener(
  "DOMContentLoaded",
  function () {
    Array.from(document.querySelectorAll(".no-orphan")).forEach((elem) => {
      let words = elem.innerHTML.trim().split(" ");
      elem.innerHTML =
        words.slice(0, words.length - 2).join(" ") +
        " " +
        "<span class='nobr'>" +
        words.slice(words.length - 2, words.length).join(" ") +
        "</span>";
    });
    
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
      }
    }
  },
  false
);
